(function () {

    ScheduleDifferentialPayService.$inject = ['ScheduleDataServiceV2', 'ShiftTemplateUtils'];

    function ScheduleDifferentialPayService (ScheduleDataServiceV2, ShiftTemplateUtils) {
        var self = this;
        var SECOND = 1;
        var MILLISECOND = 1000;
        var MINUTE = 60 * SECOND;
        var HOUR = 60 * MINUTE;
        var DAY = 24 * HOUR;
        var differentialPaySettings;

        self.setBrandDifferentialPaySettings = function (differentialPaySettingsList) {
            differentialPaySettings = differentialPaySettingsList || [];

            differentialPaySettings.sort(function (rule1, rule2) {
                return new Date(rule1['start_date']).getTime() >= new Date(rule2['start_date']).getTime() ? -1 : 1;
            });
        };

        self.getBrandDifferentialPaySettings = function () {
            return differentialPaySettings;
        };

        var isRuleAppliedOnDay = function (rule, date) {
            return moment(date).valueOf() >= moment(rule['start_date']).valueOf() &&
                (!rule['end_date'] || moment(date).valueOf() <= moment(rule['end_date']).valueOf())
        };

        self.getEffectiveRulesPerShift = function (shift) {
            var effectiveRules = [];
            var differentialPayRules = [];
            var shiftDay = shift['isExtendedFromPreviousDay'] ? shift['extendedDay'] : shift['day'];

            for (var i in differentialPaySettings) {
                if (isRuleAppliedOnDay(differentialPaySettings[i], shiftDay)) {
                    effectiveRules.push(differentialPaySettings[i]);
                }
            }

            if (effectiveRules && effectiveRules.length) {
                for (var j in effectiveRules) {
                    var rule = effectiveRules[j];
                    if (rule['payment_type'] !== 'NONE') {
                        var isCategoryPositionsRuleApplied = !rule['categories'] || rule['categories'].length === 0;

                        if (!isCategoryPositionsRuleApplied) {
                            for (var c in rule['categories']) {
                                var categoryRule = rule['categories'][c];

                                if (shift['position'] && (shift['position']['category']['code'].toLowerCase() === categoryRule['code'].toLowerCase())) {
                                    isCategoryPositionsRuleApplied = !categoryRule['positions'] || categoryRule['positions'].length === 0;

                                    if (!isCategoryPositionsRuleApplied) {
                                        for (var p in categoryRule['positions']) {
                                            if (categoryRule['positions'][p]['code'].toLowerCase() === shift['position']['code'].toLowerCase()) {
                                                isCategoryPositionsRuleApplied = true;
                                                break;
                                            }
                                        }
                                    }
                                }

                                if (isCategoryPositionsRuleApplied) {
                                    break;
                                }
                            }
                        }
                        var isSpecficDayRulesApplied = !rule['days'] || rule['days'].length === 0;
                        if (!isSpecficDayRulesApplied) {
                            for (var x in rule['days']) {
                                var ruleDay = rule['days'][x];
                                if (moment(shiftDay).format('ddd').toUpperCase() === ruleDay) {
                                    isSpecficDayRulesApplied = true;
                                    break;
                                }
                            }
                        }

                        if (isCategoryPositionsRuleApplied && isSpecficDayRulesApplied) {
                            if (rule['eligibility_to_time'] <= rule['eligibility_from_time']) {
                                rule['eligibility_to_time'] += DAY;
                            }
                            differentialPayRules.push(rule);

                        }
                    }
                }
            }
            return differentialPayRules;
        };

        var calculateShiftStartAndEndTimeInSeconds = function (shift) {
            var shiftStartTime = new Date(shift.calculatedStart);
            var shiftEndTime = new Date(shift.calculatedEnd);
            var shiftStartTimeInSeconds = shiftStartTime.getHours() * HOUR + shiftStartTime.getMinutes() * MINUTE;
            var shiftEndTimeInSeconds = shiftEndTime.getHours() * HOUR + shiftEndTime.getMinutes() * MINUTE;
            var daysDiff = (shiftEndTime.getDate() - shiftStartTime.getDate());

            if (daysDiff > 0) {
                shiftEndTimeInSeconds += (daysDiff * DAY);
            }

            if (shiftStartTimeInSeconds < (ScheduleDataServiceV2.dayOpenHour / MILLISECOND)) {
                shiftStartTimeInSeconds += DAY;
            }

            if (shiftEndTimeInSeconds <= shiftStartTimeInSeconds) {
                shiftEndTimeInSeconds += DAY;
            }


            return {
                shiftStartTimeInSeconds: shiftStartTimeInSeconds,
                shiftEndTimeInSeconds: shiftEndTimeInSeconds
            };
        };

        self.getDifferentialPayForShift = function (shift, hourlyCost) {
            var appliedDifferentialRulesForShift = [];
            var calculatedShiftStartAndEndTime = calculateShiftStartAndEndTimeInSeconds(shift);
            var effectiveDifferentialPayRules = self.getEffectiveRulesPerShift(shift);

            for (var r in effectiveDifferentialPayRules) {
                var payRule = angular.copy(effectiveDifferentialPayRules[r]);
                var payRuleObject = {title: payRule.title, amount: 0, id: payRule.id, seconds: 0, appliedPeriods: []};
                var payRuleTime = {
                    eligibility_from_time: payRule.eligibility_from_time,
                    eligibility_to_time: payRule.eligibility_to_time
                };

                if (isRuleAppliedForTheShift(payRuleTime, calculatedShiftStartAndEndTime)) {
                    var shiftStartTimeInSeconds = calculatedShiftStartAndEndTime['shiftStartTimeInSeconds'];
                    var shiftEndTimeInSeconds = calculatedShiftStartAndEndTime['shiftEndTimeInSeconds'];
                    var startEdge = shiftStartTimeInSeconds > payRuleTime['eligibility_from_time'] ? shiftStartTimeInSeconds : payRuleTime['eligibility_from_time'];
                    var endEdge = shiftEndTimeInSeconds > payRuleTime['eligibility_to_time'] ? payRuleTime['eligibility_to_time'] : shiftEndTimeInSeconds;
                    payRuleObject.appliedPeriods.push({
                        start: startEdge,
                        end: endEdge
                    });
                    var differentialPayTime = (endEdge - startEdge) || 0;

                    var appliedRuleIndex = appliedDifferentialRulesForShift.findIndex(function (rule){
                        return rule.id === payRuleObject.id;
                    });

                    if (appliedRuleIndex > -1) {
                        appliedDifferentialRulesForShift[appliedRuleIndex]['seconds'] += differentialPayTime;
                    }
                    else {
                        payRuleObject['seconds'] = differentialPayTime;

                        if ( payRuleObject['seconds'] > 0) {
                            if (payRule['payment_type'] === 'FIXED_RATE') {
                                payRuleObject['amount'] = payRule['value'] / 100;
                            } else if (payRule['payment_type'] === 'PERCENTAGE_AMOUNT') {
                                payRuleObject['amount'] = (payRule['value'] / 100) * hourlyCost;
                            }
                            appliedDifferentialRulesForShift.push(payRuleObject);
                        }
                    }

                }
            }
            return appliedDifferentialRulesForShift;
        };
        var isRuleAppliedForTheShift = function (payRule, calculatedShiftStartAndEndTime) {
            var shiftStartTimeInSeconds = calculatedShiftStartAndEndTime['shiftStartTimeInSeconds'];
            var shiftEndTimeInSeconds = calculatedShiftStartAndEndTime['shiftEndTimeInSeconds'];
            var isRuleApplied = (
                (shiftStartTimeInSeconds >= payRule['eligibility_from_time'] && shiftStartTimeInSeconds < payRule['eligibility_to_time']) ||
                (shiftEndTimeInSeconds > payRule['eligibility_from_time'] && shiftEndTimeInSeconds <= payRule['eligibility_to_time']) ||
                (shiftStartTimeInSeconds < payRule['eligibility_from_time'] && shiftEndTimeInSeconds > payRule['eligibility_to_time'])
            );

            return isRuleApplied;
        };


    }
    app.service('scheduleDifferentialPayService', ScheduleDifferentialPayService);
}());